import axios from "axios"
import {
    qsStringify
} from "../utils/querystring"
export default {
    install(Vue, {

        timeout = 60000
    }) {
        axios.defaults.timeout = timeout
        // axios.defaults.withCredentials = true
        axios.defaults.paramsSerializer = function (params) {
            return qsStringify(params)
        }

        axios.interceptors.request.use(
            async config => {
                    return config
                },
                err => {
                    return Promise.reject(err)
                }
        )
        axios.interceptors.response.use(
            (config) => {
                return config
            }, async (error) => {
                const response = error && error.response;
                if (response) {

                    let data = response && response.data
                    if (data instanceof ArrayBuffer) {
                        try {
                            data = JSON.parse(Buffer.from(data).toString() || "{}")
                        } catch (error) {
                            // continue
                        }
                    } else if (data instanceof Blob) {
                        try {
                            data = JSON.parse(await data.text() || "{}")
                        } catch (error) {
                            // continue
                        }
                    }
                    if (data && data.code) {
                        error.code = data.code
                        error.resMsg = data.message
                    }
                }
                return Promise.reject(error)
            }
        )
    }
}